import React from 'react';
import style from '@src/js/Style';
import Translation  from '@src/js/Components/Base/Translation';
import MortgageCost from './MortgageCost';
import Input from '../Form/Input';
import Select from '../Form/Select';
import Label from '../Form/Label';
import NumberFormatter from '../../NumberFormatter';
import ImageRange from '@src/js/Components/Form/ImageRange';
import Range from '../Form/Range';
import sm from '../../StorageManager';
import TranslationManager from '../../TranslationManager';
import AmortizationScheduleTable from './AmortizationScheduleTable';

export default class MortgageSalary extends MortgageCost {

    getDefaultStates() {

        return {
            salary: null,
            loanPayments: null,
            otherPayments: null,
            saving: null,
            capital: null,
            rateTerm: null,
            comfortablePayment: null,
            i18n: {yes: null, no: null, years: null},
        };
    }

    componentDidMount() {

        try {

            this
                .loadStateData()
                .then((state) => this.setState(state));
        }
        catch(error) {
        }
    }

    renderPart1() {

        return (<>

            <Input
                label={ this.state.salary.label }
                value={ this.state.salary.value }
                min={ this.state.salary.min }
                max={ this.state.salary.max }
                name='salary'
                format='number'
                suffix={ this.state.currency }
                onChange={ () => { this.useManualPayment = false; } }
                />

            <Input
                label={ this.state.loanPayments.label }
                value={ this.state.loanPayments.value }
                min={ this.state.loanPayments.min }
                max={ this.state.loanPayments.max }
                name='loanPayments'
                format='number'
                suffix={ this.state.currency }
                />

            <Input
                label={ this.state.otherPayments.label }
                value={ this.state.otherPayments.value }
                min={ this.state.otherPayments.min }
                max={ this.state.otherPayments.max }
                name='otherPayments'
                format='number'
                suffix={ this.state.currency }
                />

            <Input
                label={ this.state.saving.label }
                value={ this.state.saving.value }
                min={ this.state.saving.min }
                max={ this.state.saving.max }
                name='saving'
                format='number'
                suffix={ this.state.currency }
                />

            {/* capital */}
            <div className={ style('flex flex-wrap gap w-full') }>

                <Label className={ style('w-full') }>{ this.state.capital.label }</Label>

                <div className={ style('flex items-center justify-between gap w-full') }>

                    <Select className={ style('w-3/12') } value={ this.state.capital.using }
                        onChange={ (e) => this.changeCapitalUsingEvent(e) }>
                        <option value={ 1 }>{ this.state.i18n.yes }</option>
                        <option value={ 0 }>{ this.state.i18n.no }</option>
                    </Select>

                    <Input
                        value={ this.state.capital.value }
                        min={ this.state.capital.min }
                        max={ this.state.capital.max }
                        name='capital'
                        format='number'
                        suffix={ this.state.currency }
                        />

                </div>

            </div>

            {/* credit rate and term */}
            <div className={ style('flex flex-wrap gap w-full') }>

                <Label className={ style('w-full') }>{ this.state.rateTerm.label }</Label>

                <div className={ style('flex items-center justify-between gap w-full') }>

                    <Input
                        groupClassName={ style('w-3/12') }
                        value={ this.state.rate.value }
                        min={ this.state.rate.min }
                        max={ this.state.rate.max }
                        name='credit_rate'
                        format='number'
                        suffix='%'
                        />

                    <Input
                        value={ this.state.term.value }
                        min={ this.state.term.min }
                        max={ this.state.term.max }
                        name='credit_term'
                        format='number'
                        suffix={ this.state.term.suffix }
                        data={{ alias: 'term' }}
                        />

                </div>

            </div>

            {/* comfortable payment */}
            <div className={ style('w-full') }>
                { this.state.comfortablePayment.title }
                <strong ref={ (node) => { this.nodes.comfortablePayment = node; } }>
                    { this.state.comfortablePayment.value.formatted() }
                </strong>
            </div>
            
            <div className={ style('title4 w-full') }>
                { this.state.comfortablePayment.changeLabel }
            </div>
            
            <Range
                step={ 100 }
                min={ this.state.comfortablePayment.min }
                max={ this.state.comfortablePayment.max }
                value={ this.state.comfortablePayment.value.toFloat() }
                onChange={ (e) => this.changeComfortablePaymentEvent(e) }
                />
            
            <div
                className={ style('mt-2 w-full') }
                dangerouslySetInnerHTML={{ __html: this.state.comfortablePayment.text }}></div>
            
        </>);
    }

    renderPart2(isMobile) {

        return (<>
        
            { !isMobile ? this.renderImageRange() : null }

            <div className={ style('flex-grid-2 w-full loader') } ref={ (node) => { this.nodes.details = node; } }>

                { this.renderDetail(this.state.comfortableSum) }
                { this.renderDetail(this.state.comfortablePayment) }
                { this.renderDetail(this.state.initFee, this.state.currency) }
                { this.renderDetail(this.state.details.sum) }
                { this.renderDetail(this.state.details.sumOverpayment, this.state.currency) }
                { this.renderDetail(this.state.term, this.state.i18n.years) }

            </div>
            
            { this.renderControls() }

        </>);
    }

    renderDetail(props, forceSuffix = null) {

        return (
            <div className={ style('w-full') }>
                <label className={ style('text-muted text-medium w-full') }>{ props.label }</label>
                <div className={ style('text-medium w-full loader__child') }>
                    { NumberFormatter.parse(props.value, 0, forceSuffix).formatted() }
                </div>
            </div>
        );
    }

    renderImageRange() {

        return <ImageRange
            items={ this.state.price.images }
            value={ this.state.comfortableSum.value.toFloat() } />;
    }

    async loadStateData() {

        await TranslationManager.loadAll(['interface.yes', 'interface.no', 'years']);
        const i18n = {
            yes: await TranslationManager.get('interface.yes'),
            no: await TranslationManager.get('interface.no'),
            years: await TranslationManager.get('years'),
        };

        return new Promise((resolve) => {

            super
                .loadStateData()
                .then((state) => {

                    state.i18n = i18n;

                    const
                        
                        country = 'App\\Entity\\Geo\\Country',
                        calculator = 'App\\Entity\\Service\\Calculator';

                    state.term.suffix = this.state.i18n.years;

                    state.salary = this.form.state.salary;

                    state.loanPayments = this.form.state.loanPayments;

                    state.otherPayments = this.form.state.otherPayments;

                    state.saving = this.form.state.saving;

                    state.capital = this.form.state.capital;
                    state.capital.using = true;
    
                    state.rateTerm = {
                        label: sm.get(country, 'mortgageRateTermLabel'),
                    };
    
                    const comfortablePaymentDesc = sm.get(country, 'mortgageComfortablePaymentDesc', true);

                    state.comfortablePayment = {
                        label: comfortablePaymentDesc.label,
                        title: comfortablePaymentDesc.title,
                        changeLabel: comfortablePaymentDesc.changeLabel,
                        text: comfortablePaymentDesc.text,
                        value: new NumberFormatter(0, state.currency),
                        min: 0,
                        max: 0,
                        maxPercent: sm.get(calculator, 'mortgageComfortablePaymentPercent'),
                    };
    
                    state.comfortableSum = {
                        label: sm.get(country, 'mortgageComfortableSumLabel'),
                        value: new NumberFormatter(0, state.currency),
                    };

                    resolve(state);
                });
        });
    }

    submit() {

        this.nodes.alarm.hideAll();

        this.setIsLoading(true);

        // calc comfortable payment amount

        if (!this.useManualPayment) {

            const comfortablePaymentValue = this.calcComfortablePayment();

            this.state.comfortablePayment.value.set(comfortablePaymentValue).div(2);
            this.state.comfortablePayment.max = comfortablePaymentValue.toInt();
        }

        // calc comfortable sum & credit sum
        this.state.initFee.value = this.findInitFee();
        this.state.comfortableSum.value = this.findComfortableSum();
        this.state.details.sum.value = this.findCreditSum(this.state.comfortableSum.value);

        if (this.state.details.sum.value.toInt() > 0) {

            const query = this.updateReportQuery();

            query
                .setOption('creditSum', this.state.details.sum.value.toFloat())
                .setOption('initFee', {
                    value: this.state.initFee.value.toFloat(),
                    unit: 'money'
                })
                .fetch()
                .then((response) => {

                    this.nodes.form.response = response;

                    this.form.handleResponse(query, response);

                    this.state.details.sumOverpayment.value = NumberFormatter.parse(response.report.details.sumOverpayment,
                        this.state.currency);
    
                    this.setState({
                        comfortablePayment: this.state.comfortablePayment,
                        comfortableSum: this.state.comfortableSum,
                        creditSum: this.state.creditSum,
                        details: this.state.details,
                        table: new AmortizationScheduleTable(response),
                    });

                    if (this.props.onSubmit)
                        this.props.onSubmit(new CustomEvent('submit', { detail: {
                            target: this.nodes.form,
                            response,
                        } }));
    
                    this.setIsLoading(false);
                });
        }
        else {

            this.state.details.sumOverpayment.value = new NumberFormatter(0, this.state.currency);

            this.setState({
                comfortablePayment: this.state.comfortablePayment,
                comfortableSum: this.state.comfortableSum,
                creditSum: this.state.creditSum,
                details: this.state.details,
            });
            this.setIsLoading(false);
        }
    }

    calcComfortablePayment() {

        const comfortablePaymentValue = this.state.salary.value.clone();
        comfortablePaymentValue
            .minus((comfortablePaymentValue.toInt() / 100) * this.state.comfortablePayment.maxPercent)
            .minus(this.state.loanPayments.value)
            .minus(this.state.otherPayments.value);

        if (comfortablePaymentValue.toInt() < 0)
            comfortablePaymentValue.set(0);

        return comfortablePaymentValue;
    }

    findComfortableSum() {

        const sum = this.state.comfortablePayment.value.clone();
        sum.multiple(NumberFormatter.parse(this.state.term.value).multiple( /* months */ 12));

        return sum;
    }

    findInitFee() {

        const initFee = new NumberFormatter(0);
        initFee.plus(this.state.saving.value);

        if (this.state.capital.using === 1)
            initFee.plus(this.state.capital.value)

        return initFee;
    }

    findCreditSum(sum) {

        const creditBody = sum.clone();
        creditBody.minus(this.state.initFee.value);
        
        if (creditBody.toInt() < 0)
            creditBody.set(0);

        return creditBody;
    }

    changeCapitalUsingEvent(e) {
        
        this.state.capital.using = e.detail.value;
        this.debounceSubmit();
    }

    changeComfortablePaymentEvent(e) {

        this.useManualPayment = true;

        this.state.comfortablePayment.value.set(e.target.value);
        this.state.comfortableSum.value = this.findComfortableSum();
        this.state.details.sum.value = this.findCreditSum(this.state.comfortableSum.value);

        this.nodes.comfortablePayment.innerText = this.state.comfortablePayment.value.formatted();

        this
            .debounceSubmit()
            .then((success) => {

                if (success) {

                    this.setState({
                        comfortablePayment: this.state.comfortablePayment,
                    });
                }
            });
    }
}